/**
 * V2's introductions, once each (the pattern of new-since.ts: remembered per browser; if storage is blocked they never
 * show, rather than showing every time).
 *   - "Two pens, and a pocket": above the line, the first time a player opens a story with V2. Seen once they tap any of
 *     its links, pick the Thread pen themselves, or reach the tour's step on the pens.
 *   - The first Thread line: one hint under the line, the first time the Thread pen is picked.
 * A player who had played before V2 on this browser (the tour was done) is told it's new.
 */
/** Played here before: the tour was done (onboarding.tsx's key, read directly: importing it would make an import cycle
 *  through common.tsx), or a story was opened (App's last-story key). */
const onboarded = () => localStorage.getItem("loom:onboarded") === "1" || !!localStorage.getItem("loom:last-story");

const INTRO_KEY = "weftwake.v2-intro", THREAD_KEY = "weftwake.v2-thread-hint";

/** Recorded the first time V2 runs in this browser: had this player been here before V2? */
const SINCE_KEY = "weftwake.v2-since";
function since(): "returning" | "new" {
  try {
    const was = localStorage.getItem(SINCE_KEY);
    if (was === "returning" || was === "new") return was;
    const now = onboarded() ? "returning" : "new";
    localStorage.setItem(SINCE_KEY, now);
    return now;
  } catch {
    return "new";
  }
}
// Read as early as possible: before this visit's tour can set "onboarded".
since();
export const returning = () => since() === "returning";

const flag = (k: string) => { try { return localStorage.getItem(k) === "1"; } catch { return true; } };
const set = (k: string) => { try { localStorage.setItem(k, "1"); } catch { /* shown again: fine */ } };

export const introDue = () => !flag(INTRO_KEY);
export const introSeen = () => set(INTRO_KEY);
export const threadHintDue = () => !flag(THREAD_KEY);
export const threadHintSeen = () => set(THREAD_KEY);
